import {styled} from "@mui/material/styles";
import {Link} from "react-router-dom";

export const RbLink = styled(Link)(() => ({
    color: "inherit !important",
    textDecoration: "none !important"
}));

